import React from "react";
import Helmet from "react-helmet";
import Link from "gatsby-link";
import Product from "../components/product/Product";
import { CardDeck } from "reactstrap";
import Slider from "react-slick";

import "./index.scss";

var settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: true,
};

const Home = () => (
  <div className="home">
    <Helmet title={`Datasert - Home`} />

    <div className="slides">
      <Slider {...settings}>
        <div className="slide">
          <h2>Realsync</h2>
          <h3>Near Realtime Data Sync, History, Backup and Restore</h3>
          <img
            src={require("./products/realsync/images/realsync-overview.png")}
          />
        </div>
        <div className="slide">
          <h2>Realfire</h2>
          <h3>Take Salesforce Data Management to Next Level</h3>
          <img
            src={require("./products/realfire/features/query-editor/enter-queries.png")}
          />
        </div>
        <div className="slide">
          <h2>Scheduleright</h2>
          <h3>Enterprise Grade Job Scheduling for Salesforce</h3>
          <img
            src={require("./products/scheduleright/features/scheduler-job-details.png")}
          />
        </div>
      </Slider>
    </div>

    <div className="products">
      <a name="products"></a>
      <h2>Datasert Products</h2>
      <CardDeck className="products-list">
        <Link to="/products/realsync">
          <Product
            title="Realsync"
            description="Near Realtime Data Sync, History, Backup and Restore"
          ></Product>
        </Link>
        <Link to="/products/realfire">
          <Product
            title="Realfire"
            description="Productive Salesforce Data managemeent"
          ></Product>
        </Link>
        <Link to="/products/scheduleright">
          <Product
            title="Scheduleright"
            description="Enterprise Grade Job Scheduler for Salesforce"
          ></Product>
        </Link>
        <Link to="/products/libshare">
          <Product
            title="Libshare"
            description="Battle tested and open sourced reusable modules for Salesforce"
          ></Product>
        </Link>
        {/*<Link to="/products/awsconnect">*/}
        {/*  <Product*/}
        {/*    title="Awsconnect"*/}
        {/*    description="Missing Aws SDK for Salesforce"*/}
        {/*  ></Product>*/}
        {/*</Link>*/}
      </CardDeck>
    </div>
    <div className="testimonials">
      <h1>Trusted by 1000s of users worldwide</h1>
    </div>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/pages/index.jsx